import { render, staticRenderFns } from "./QrcodeBindAllot.vue?vue&type=template&id=335c0013&scoped=true&"
import script from "./QrcodeBindAllot.vue?vue&type=script&lang=js&"
export * from "./QrcodeBindAllot.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeBindAllot.vue?vue&type=style&index=0&id=335c0013&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c0013",
  null
  
)

export default component.exports